// extracted by mini-css-extract-plugin
export var close = "CloseButton-module--close--7edf9";
export var light = "CloseButton-module--light--97ae0";
export var closeIcon = "CloseButton-module--closeIcon--acdd6";
export var sm = "CloseButton-module--sm--84b2a";